import { Link } from "react-router-dom";
import { Linkedin, Mail, ArrowUpRight } from "lucide-react";

const LINKEDIN_URL =
  "https://www.linkedin.com/in/vicente-palomarez-b89290109/";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border bg-background"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <p className="font-mono-ui text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
            VINCENTPALOMAREZ.COM
          </p>
          <h3 className="font-display font-black text-2xl mt-3 max-w-md">
            Sustainable high performance in the AI era.
          </h3>
          <p className="text-sm text-muted-foreground mt-3 max-w-md">
            Enterprise sales leader across Technology, Energy & Medical.
            Sharing lessons on leadership, habits, and the Corporate Athlete 2.0 framework.
          </p>
          <p
            data-testid="footer-availability"
            className="text-xs font-mono-ui uppercase tracking-[0.22em] text-accent mt-5"
          >
            Open to selective fractional and advisory engagements.
          </p>
        </div>

        <div>
          <p className="font-mono-ui text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
            Explore
          </p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link data-testid="footer-about-link" to="/about" className="hover:text-foreground text-muted-foreground">About</Link></li>
            <li><Link data-testid="footer-experience-link" to="/experience" className="hover:text-foreground text-muted-foreground">Experience</Link></li>
            <li><Link data-testid="footer-ca-link" to="/corporate-athlete" className="hover:text-foreground text-muted-foreground">Corporate Athlete 2.0</Link></li>
            <li><Link data-testid="footer-insights-link" to="/insights" className="hover:text-foreground text-muted-foreground">Insights</Link></li>
          </ul>
        </div>

        <div>
          <p className="font-mono-ui text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
            Connect
          </p>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <a
                data-testid="footer-linkedin-link"
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground group"
              >
                <Linkedin className="h-3.5 w-3.5" />
                LinkedIn
                <ArrowUpRight className="h-3 w-3 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </li>
            <li>
              <Link
                data-testid="footer-contact-link"
                to="/contact"
                className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground"
              >
                <Mail className="h-3.5 w-3.5" />
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p className="text-xs font-mono-ui text-muted-foreground">
            © {year} Vincent Palomarez. All rights reserved.
          </p>
          <p className="text-xs font-mono-ui text-muted-foreground">
            Built with intent · Corporate Athlete 2.0
          </p>
        </div>
      </div>
    </footer>
  );
}
